import type { IApplication } from "@/modules/application/common/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface ApplicationState {
  application?: IApplication | null;
  rowId?: string | null;
}

const initialState: ApplicationState = {
  application: null,
  rowId: "",
};

const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setApplicationRowId(state, { payload }: PayloadAction<{ rowId?: string | null } | null>) {
      state.rowId = payload?.rowId;
    },
    setApplication(
      state,
      { payload }: PayloadAction<{ application?: IApplication | null } | null>
    ) {
      state.application = payload?.application;
    },

  },
});

export const {
  setApplicationRowId,
  setApplication,
} = applicationSlice.actions;
export default applicationSlice.reducer;
